import { render } from "./rectorStudioManager.vue?vue&type=template&id=31361316&scoped=true"
import script from "./rectorStudioManager.vue?vue&type=script&lang=js"
export * from "./rectorStudioManager.vue?vue&type=script&lang=js"

import "./rectorStudioManager.vue?vue&type=style&index=0&id=31361316&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31361316"]])

export default __exports__